import styled from 'styled-components';

import { BREAKPOINTS } from 'utils/constants';

const MainContent = styled.main`
    position: relative;
        
    @media screen and (min-width: ${BREAKPOINTS.smallTabletBreakpoint}) {
        width: calc(100% - 7.25rem);
        margin-left: 6.25rem;
        margin-bottom: 1rem;
        padding: 0;
        box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .5);
    }
    
    @media screen and (min-width: ${BREAKPOINTS.tabletBreakpoint}) {
        width: calc(100% - 10.25rem);
        margin-left: 7.75rem;
        margin-bottom: 2.5rem;
    }
    
    @media screen and (min-width: ${BREAKPOINTS.desktopBreakpoint}) {
        width: calc(100% - 29.375rem);
    }
`;

export default MainContent;



// WEBPACK FOOTER //
// ./src/containers/App/MainContent.js